import { useMemo } from 'react';

import { useSelector } from '../../../shared/utils';

interface UseAllowedRolesResult {
  roles: string[];
  error: boolean;
}

/**
 * Reads the allowed roles from Redux state (`MTA_CLIENT_CRED_ALLOWED_ROLES`).
 * The value is a comma-separated string of role names provided by the host app
 * (e.g. `"ROLE_ADMIN,ROLE_VIEWER"`).
 * Returns an error flag when the value is falsy or contains no roles.
 */
export function useAllowedRoles(): UseAllowedRolesResult {
  const raw = useSelector(
    (s) => s.user.domainInfo.MTA_CLIENT_CRED_ALLOWED_ROLES
  );

  return useMemo(() => {
    if (!raw) {
      return { roles: [], error: true };
    }

    const roles = raw
      .split(',')
      .map((r) => r.trim())
      .filter(Boolean);

    if (roles.length === 0) {
      return { roles: [], error: true };
    }

    return { roles, error: false };
  }, [raw]);
}
